import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { RunnerSetupDeleteSearch } from './RunnerSetupDeleteSearch';

export const runnerSetupDeleteSearchBridge = react2angular(RunnerSetupDeleteSearch, [
  'entityToDelete',
  'entityName',
  'entityType',
  'teams',
  'users',
  'managers',
  'reassignActorRequired',
  'onActorChosen',
  'reassignCustomDatabaseRequired',
  'reassignCategoryApproverRequired',
  'reassignStepTasksRequired'
]);
